import { h, FunctionalComponent } from "preact";

interface Props {
  loading: boolean;
  currentPage: number;
  totalPages: number;
  onClickPreviousPage: () => void;
  onClickNextPage: () => void;
}

const Pagination: FunctionalComponent<Props> = ({
  loading,
  currentPage,
  totalPages,
  onClickPreviousPage,
  onClickNextPage,
}) => (
  <div className="pagination">
    <button
      onClick={onClickPreviousPage}
      className="pagination__btn"
      disabled={loading || currentPage === 0}
    >
      <i className="icon icon-arrow icon-arrow-left" />
    </button>
    <span className="pagination__pages">
      {currentPage + 1} sur {totalPages}
    </span>
    <button
      onClick={onClickNextPage}
      className="pagination__btn"
      disabled={loading || currentPage === totalPages - 1}
    >
      <i className="icon icon-arrow icon-arrow-right" />
    </button>
  </div>
);

export default Pagination;
